// extracted by mini-css-extract-plugin
export default {"root":"Sz76tnSclP","root_clickable":"CJMOxxYnz2","image":"WqNcDUNxM8"};